<template>
    <div class="app-container">
      <AddForm ref="addFormRef" :business-type="ORDER_BUSINESS_TYPES.COMMON" @onSave="onSave" />
    </div>
  </template>
  <script>
  import AddForm from '@/views/center-business/csgOrder/internal/components/AddForm';
  import { ORDER_BUSINESS_TYPES } from '@/utils/constants.js';
  import { orderApi } from '@/api';

  export default {
    name: 'BusinessOrderInternalEditCSG',
    components: {
      AddForm,
    },
    data() {
      return {
        ORDER_BUSINESS_TYPES,
      };
    },
    methods: {
      // 编辑保存订单  editInternalOrder
      onSave(POST_DATA) {
        // if(this.$route.query.status==3){
          orderApi.updateInternalProccessingOrder(POST_DATA).then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$refs.addFormRef.dataClear();
            }
          });
        // }else{
        //   orderApi.editInternalOrder(POST_DATA).then(res => {
        //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
        //       this.$refs.addFormRef.dataClear();
        //     }
        //   });
        // }
      }
    }
  };
  </script>
